export default {
  // Generic actions
  actions: {
    cancel: "Откажување",
    close: "Затворање",
    save: "Зачувување",
    add: "Додавање",
    edit: "Уредување",
    apply: "Применување",
    confirm: "Потврдување",
    delete: "Бришење",
    remove: "Отстранување",
    refresh: "Освежување",
    reset: "Воспоставување на промените",
    reset_short: "Воспоставување",
  },

  // Generic messages
  messages: {
    loading: "Вчитување...",
    loading_info: "Вчитување на информации...",
    saving: "Зачувување на промените...",
    deleting: "Бришење...",
    noData: "Нема достапни податоци",
    error: "Се појави грешка",
  },

  // Unsaved-changes guard dialog
  unsaved: {
    subtitle: "Имате незачувани промени.",
    body: "Дали сакате да ги зачувате промените пред затварањето, или да ги отфрлите?",
  },

  optional: "незадолжително",

  // Common button patterns
  buttons: {
    clearAll: "Исчистување на сè",
    selectAll: "Избирање на сè",
    deselectAll: "Отселектирање на сè",
  },

  titles: {
    sample_info: "Информации за примерок: {barcode}",
  },

  //
  // Sample Info Dialog
  //
  sample_info: {
    tabs: {
      basic_info: "Основни информации",
      instruments: "Апарати",
      results_sets: "Сетови на резултати",
    },

    results_sets_table: {
      group_name: "Сет",
    },
  },
};
